import { Loader } from '../../components';
import { memo } from 'react';
import { useActiveLoan } from 'pages/ActiveLoan/useActiveLoan';
import { useApplication, useLatestLoan } from 'hooks/webapi';
import ExtensionsNotOverdue from './ExtensionsNotOverdue';
import ExtensionsOverdue from './ExtensionsOverdue';

// @TODO: refactor the whole screen
export default memo(function Extensions() {
  const { isOverdue } = useActiveLoan();
  const { application } = useApplication();
  const { latestLoan } = useLatestLoan();

  if (!application || !latestLoan) return <Loader />;

  if (isOverdue) return <ExtensionsOverdue />;

  return <ExtensionsNotOverdue />;
});
